import { combineReducers } from "redux";
import { LandingSlice, ProposalSlice, QuotesPageSlice } from "../pages";
export default combineReducers({
  input: LandingSlice,
  quotes: QuotesPageSlice,
  proposal: ProposalSlice,
});
